import { Button as BaseButton, SearchOutlined } from 'core/components/ui';

type Props = {
  handleSearchBox: () => void;
  children?: React.ReactNode[] | string;
};

export function Button({ handleSearchBox, children }: Props): JSX.Element {
  return (
    <BaseButton onClick={handleSearchBox} icon={<SearchOutlined />}>
      {children || 'Search'}
    </BaseButton>
  );
}
